import React, {Component} from 'react'
import {Container, StartProcedureCard} from 'features/procedures/StartProcedureCard'
import {actionCreators} from 'actions'
import api from 'api'
import Modal from 'components/Modal'
import Button from 'jbc-front/components/Button'
import queryString from 'query-string'
import {connect} from 'react-redux'
import withRouterLegacy from 'withRouterLegacy'
import {notifySuccess} from 'store/actions/notify'
import {asyncError} from 'store/actions/asyncError'

class ChooseExtendOrFinish extends Component {
  constructor(props) {
    super(props)
    this.state = {
      submitting: false,
    }
  }

  componentDidMount() {
    const {
      location: {search},
      loadProcedureStatus,
      token,
    } = this.props
    const {procedure_id} = queryString.parse(search)
    loadProcedureStatus(procedure_id, token)
  }

  async handleSubmit(id, token) {
    const {reportBirth} = this.props
    this.setState({submitting: true})
    await reportBirth(id, token, this.props.history)
    this.setState({submitting: false})
  }

  render() {
    const {procedureStatus, token} = this.props
    return (
      <Modal>
        {({hideModal, showModal, isOpen}) => {
          const dateOn = procedureStatus?.procedure_start_maternity_datum?.expected_birth_date?.replace(/-/g, '/')
          return (
            <>
              <div>
                <div className="l-title-wrap">
                  <h1 className="m-title-main">出産日を報告</h1>
                  {dateOn && <p className="m-title-main-note">{`出産予定日：${dateOn}`}</p>}
                </div>
                <Container>
                  <StartProcedureCard onClick={showModal} variant="start">
                    出産予定日に出産
                  </StartProcedureCard>
                  <StartProcedureCard
                    to={`/extend_maternity/employee_input?procedure_id=${procedureStatus.id}`}
                    variant="start"
                  >
                    出産予定日と
                    <br />
                    異なる日に出産
                  </StartProcedureCard>
                </Container>
              </div>
              {isOpen && (
                <Modal.Modal>
                  <Modal.Header>出産予定日に出産した</Modal.Header>
                  <Modal.Body>
                    <div>
                      管理者に出産予定日通りに出産したことを報告します。
                      <br />
                      よろしいですか？
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Modal.Buttons>
                      <Button onClick={hideModal}>キャンセル</Button>
                      <Button
                        primary
                        onClick={() => this.handleSubmit(procedureStatus.id, token)}
                        disabled={this.state.submitting}
                      >
                        報告
                      </Button>
                    </Modal.Buttons>
                  </Modal.Footer>
                </Modal.Modal>
              )}
            </>
          )
        }}
      </Modal>
    )
  }
}

export default withRouterLegacy(
  connect(
    (state) => ({
      procedureStatus: state.procedureStatuses.current.data,
      token: state.auth.token,
    }),
    (dispatch) => ({
      loadProcedureStatus: (id, token) => {
        dispatch(
          actionCreators.procedureStatuses.current.fetchData(
            api.createWithAuth(token).procedureStatuses.get(id, ['employee', 'procedure_maternity_datum'])
          )
        )
      },
      reportBirth: async (id, token, history) => {
        try {
          await api.createWithAuth(token).procedureStatuses.maternity.reportBirth(id)
          history.push('/dashboard')
          dispatch(notifySuccess('報告しました'))
        } catch (err) {
          dispatch(asyncError(err))
        }
      },
    })
  )(ChooseExtendOrFinish)
)
